import DatetimeUtils from "../../gd/utils/datetime-utils";


export default class Reaction {

    public type            : number
    public userId          : ID
    public moment          : Moment

    constructor(type: number, userId: ID, moment: Moment) {
        this.type          = type
        this.userId        = userId
        this.moment        = moment
    }

    static initFromJson(data:JSONObject):Reaction {
        return new Reaction(
            data.type as number,
            data.userId as ID,
            DatetimeUtils.datetimeToMoment(data.moment as string)
        )
    }

    toJSON():JSONObject {
        return {
            type        : this.type,
            userId      : this.userId,
            moment      : DatetimeUtils.momentToUTCISODatetime(this.moment)
        }
    }

}